var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"map-container"}},[(_vm.noGPS)?_c('div',{attrs:{"id":"no-gps-warning"}},[_c('span',[_vm._v(_vm._s(_vm.$t("No GPS signal")))])]):_vm._e(),_c('div',{attrs:{"id":"map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }